import { createSlice } from "@reduxjs/toolkit";

const filtersParticipantSlice = createSlice({
  name: "filtersParticipant",
  initialState: {
    filters: {
      sort: {},
      filters: {},
    },
  },
  reducers: {
    setFiltersParticipant: (state, action) => {
      state.filters = {
        sort: action.payload.sort,
        filters: action.payload.filters,
      };
    },
    resetFiltersParticipant: (state) => {
      state.filters = {
        sort: {},
        filters: {},
      };
    },
  },
});

export const { setFiltersParticipant, resetFiltersParticipant } =
  filtersParticipantSlice.actions;
export default filtersParticipantSlice.reducer;
